import type { Feature } from '@luna/gatekeeper';

export const cardReissue: Feature = {
    enabled: false,
    _description:
        'Enables the card reissue feature display on the bank card settings page and card features page',
};
